import React, { useContext } from 'react';
import { AppFormContext, AppFormItemProps } from '../AppForm/index';
import { AppSelect, AppSelectProps } from '../AppSelect';


export const AppFormItemSelect = (props: AppFormItemProps) => {

  const { onChange, formData } = useContext(AppFormContext);
  const selectProps = { ...props } as AppSelectProps;


  const handleChange = (value: string | number, text: string) => {
    let itemProps = { ...props, value } as AppFormItemProps;
    onChange && onChange(itemProps);
  }


  return <AppSelect {...selectProps} value={`${formData[props.keyName] || ''}`} onChange={handleChange} />
}



// WEBPACK FOOTER //
// ./src/qcc/AppFormItem/AppFormItemSelect.tsx